// ゴブリン：速い追跡＋接触ダメージ。4方向歩行アニメ
import Phaser from 'phaser';
import { Enemy } from '../Enemy';
import { DIR_ROW } from '../../data/Directions';

export class Goblin extends Enemy {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'goblin');
  }

  static defineAnimations(scene: Phaser.Scene): void {
    const dirs = ['down', 'left', 'right', 'up'] as const;
    for (const d of dirs) {
      const key = `goblin-walk-${d}`;
      if (scene.anims.exists(key)) continue;
      const start = DIR_ROW[d] * 3;
      scene.anims.create({
        key,
        frames: scene.anims.generateFrameNumbers('enemy_goblin', {
          start,
          end: start + 2,
        }),
        frameRate: 6,
        repeat: -1,
      });
    }
  }

  protected override playWalkAnim(): void {
    const key = `goblin-walk-${this.facing}`;
    if (this.anims.currentAnim?.key !== key) this.anims.play(key, true);
  }
}
